import React, { useMemo, useReducer, useContext } from "react";
import { TYPES as t } from "./types";

const initialState = {
  page_settings: window.CONTACT_FORM?.page_settings || { page_settings: {} },
  products: window.CONTACT_FORM?.products || [],
  activeStep: 0,
  isLoading: false,
};

export const UIContext = React.createContext(initialState);

UIContext.displayName = "UIContext";

function uiReducer(state, action) {
  switch (action.type) {
    case t.SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }

    case t.NEXT_STEP: {
      return {
        ...state,
        activeStep: ++state.activeStep,
      };
    }

    case t.PREV_STEP: {
      return {
        ...state,
        activeStep: --state.activeStep,
      };
    }
  }
}

export const UIProvider = (props) => {
  const [state, dispatch] = useReducer(uiReducer, initialState);

  const setIsLoading = (payload) => dispatch({ type: t.SET_IS_LOADING, payload });
  const nextStep = (payload) => dispatch({ type: t.NEXT_STEP });
  const prevStep = (payload) => dispatch({ type: t.PREV_STEP });

  const value = useMemo(
    () => ({
      ...state,
      setIsLoading,
      nextStep,
      prevStep,
    }),
    [state]
  );

  return <UIContext.Provider value={value} {...props} />;
};

export const useUI = () => {
  const context = useContext(UIContext);

  if (context === undefined) {
    throw new Error(`useUI must be used within a UIProvider`);
  }
  return context;
};

export const ManagedUIContext = ({ children }) => <UIProvider>{children}</UIProvider>;
